module.exports = __webpack_public_path__ + "static/img/h5.fb9cfd7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/h5.jpeg
// module id = M6gY
// module chunks = 2